import { instana } from "@crystal/analytics";
import { version } from "../clients/account-portal/package.json.js";
const FrontendName = "AccountPortalAuthn";
const AuthnEvents = {
  PortalInlineView: "AccountPortal_InlineView",
  PortalOpened: "AccountPortal_Opened",
  PortalClosed: "AccountPortal_Closed",
  AuthSuccess: "Authentication_Success",
  ExternalAuthStart: "ExternalAuth_Start",
  ExternalAuthProcess: "ExternalAuth_Process",
  ExternalAuthError: "ExternalAuth_Error",
  MicrofrontendError: "AccountPortal_Error",
  ActionError: "AccountPortal_Action_Error"
};
function instanaEventAuthn(event, meta, error) {
  instana("page", (meta == null ? void 0 : meta.pageName) || FrontendName);
  instana("reportEvent", event, {
    ...error,
    meta: {
      clientVersion: version,
      // npm client version
      ...meta
    }
  });
}
function instanaSessionEventAuthn(user) {
  instana("page", FrontendName);
  instana("user", user.acid);
  instana("meta", "isPersistent", user.session.isPersistent);
  instana("meta", "isNewUser", user.session.isNewUser);
}
export {
  AuthnEvents,
  FrontendName,
  instanaEventAuthn,
  instanaSessionEventAuthn
};
//# sourceMappingURL=monitoring.js.map
